import { PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { useStatelessGet } from '../utils/useStatelessGet';
import { Country, CountryContext } from './CountryContext';

export const CountryProvider = ({ children }: PropsWithChildren) => {
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState<Country[] | undefined>(undefined);
  const getCountries = useStatelessGet<Country[]>('/student-portal/countries');

  const fetchCountries = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getCountries();
      setCountries(response);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  }, [getCountries]);

  useEffect(() => {
    fetchCountries();
  }, [fetchCountries]);

  return <CountryContext.Provider value={{ loading, countries }}>{children}</CountryContext.Provider>;
};
